import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

const URL_PATH = 'api/itemAta/realinhamento'

class RealinhamentoApiClient {
	async buscarHistoricoRealinhamento(idItemAta, paginacao) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/historico`,
			filters: { idItemAta: idItemAta },
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(URL)
	}

	async inserirRealinhar(dados) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/realinhar`,
		}).build()
		return await axios.put(URL, dados)
	}
}

export default new RealinhamentoApiClient()
